export function setMap(payload) {
  this.setState({ currentMap: payload });
}
